import { ApiTags, rootApi } from "../../services/rootApi"
import { UserRoleType } from "../../../modules/auth"

interface IGetConnectionsQuery {
  role?: UserRoleType
  contactId: string
}
export interface IContactConnection {
  id: string
  contactId: string
  role: UserRoleType
  connectedToContactId: string
}

export interface IContactConnectionsResponse {
  selectedEntityId?: string
  connections: IContactConnection[]
}

const TAG = ApiTags.ContactConnection;
const getTags = (entities: IContactConnection[]) => [...entities.map((p) => ({ type: TAG, id: p.id })), TAG]

const contactConnectionsApi = rootApi.injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    getConnections: builder.query<IContactConnectionsResponse,IGetConnectionsQuery>({
      query: ({role, contactId: entityId }) => `/ContactConnections/${role}/${entityId}`,
      providesTags: (result) => result ? getTags(result.connections) : [TAG]
    }),
  })
})

export const {
  useGetConnectionsQuery,
  useLazyGetConnectionsQuery,
} = contactConnectionsApi;